import { Component, OnInit, ViewChild } from '@angular/core';
import { iBisLanguageService, iBisUIService, iBisViewComponent } from '@dohu/ibis-common';
import { TechnicalService } from '../technical.service';
import DataSource from 'devextreme/data/data_source';
import { ClarificationResponseService } from '../../common/clarification-response/clarification-response.service';
import { DataService } from '../../services';
import { ModalFileService } from '../../common/modal-file/modal-file.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ContentReadyEvent } from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-technical-clarification',
  templateUrl: './technical-clarification.component.html'
})
export class TechnicalClarificationComponent extends iBisViewComponent implements OnInit {
  clarifications!: DataSource;
  private wordWrapSet = false;

  @ViewChild('clarificationGrid') override grid!: DxDataGridComponent;
  constructor(public override edit: ClarificationResponseService,
    lg: iBisLanguageService, iui: iBisUIService, public tech: TechnicalService,
    public ds: DataService, public modalFile: ModalFileService) {
    super(edit, lg, iui, <any>null);
    this.id = 'c_id';
    this.key = 'technical-clarification';
  }

  ngOnInit(): void {
    this.clarifications = this.tech.getClarification();
  }

  onGridReady(ev: ContentReadyEvent): void {
    if (!this.wordWrapSet) {
      ev.component.option('wordWrapEnabled', true);
      this.wordWrapSet = true;
    }
  }

  onAttachClick = (ev: any) => {
    this.modalFile.title = this.L("CLARIFICATION_ATTACHMENTS");
    this.modalFile.showPopup({ id: ev.row.data.c_id })
  }

  attachVisible = (ev: any) => {
    return ev.row.data && ev.row.data.fc_fileNo;
  }

  clarificationResponse = (ev: any) => {
    const obj = { id: ev.row.data.c_id, responseFileId: ev.row.data.c_responseFileId };
    this.edit.showPopup(obj, true).then(resp => {
      ev.component.refresh();
    })
  }

  onProductListRdy(ev: any, data: any) {
    if (ev.component.option('dataSource') == null) {
      ev.component.option('dataSource', this.tech.getProductList(data.c_rfqId));
    }
  }

}
